<template>
  <div id="app">
    <Navbar></Navbar>
    <div>
      <router-view />
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";

export default {
  components: { Navbar, Footer },
};
</script>

<style>
@font-face {
  font-family: "Lora";
  src: local("Lora"),url("./assets/fonts/Lora-VariableFont_wght.ttf");
}

@font-face {
  font-family: "Oswald";
  src: local("Oswald"),url("./assets/fonts/Oswald-Medium.ttf");
}

.full-view {
  min-height: 80vh;
}

.content-center {
  text-align: center;
}

.bg-lighter {
  background-color: white;
  color:#090d54;
  border-color: #090d54;
}

.bg-darker{
  background-color: #090d54;
  color:white;
  border-color:white;
}

.border{
  border: 1px solid;
}

.no-border{
  border:none;
}
</style>